export const formatTitleForURL = (title: string) => {
  return title
    .normalize("NFD") // Normalize to separate diacritics
    .replace(/[\u0300-\u036f]/g, "") // Remove diacritics
    .replace(/\//g, "-") // Replace slashes with dashes
    .trim()
    .replace(/\s+/g, "-"); // Replace spaces with dashes
};

export const decodeUrlTitle = (title: string) => {
  return title.trim().replace(/\s+/g, "-");
};
